import type {
  AssistantRealtimeBridgeDependencies,
  AssistantRealtimeSubscriptionHandle,
} from '../contracts/assistant-realtime-contracts';

export const createAssistantRealtimeBridge = (deps: AssistantRealtimeBridgeDependencies) => ({
  start: (input: {
    actorId: string;
    pathname?: string;
    persona?: string;
  }): AssistantRealtimeSubscriptionHandle => {
    const actorId = String(input.actorId ?? '').trim();
    if (!actorId) {
      throw new Error('assistant realtime bridge requires actorId.');
    }

    deps.store.connectionStateChanged({
      status: 'connecting',
      nowEpochMs: Date.now(),
    });

    const subscription = deps.subscription.open({
      session: {
        isAuthenticated: true,
        persona: input.persona ?? 'unknown',
        token: null,
        userSub: actorId,
        expiresAtEpochMs: null,
        groups: [],
        source: 'unknown',
      },
      actorId,
      persona: input.persona,
      pathname: input.pathname,
      onEvent: (bridgeEvent) => {
        const eventId = String(bridgeEvent.event.id ?? '').trim();
        if (!eventId || deps.store.hasSeenEvent({ eventId })) {
          return;
        }
        deps.store.connectionStateChanged({
          status: 'connected',
          nowEpochMs: bridgeEvent.receivedAtEpochMs,
        });
        deps.store.eventReceived(bridgeEvent);
      },
      onError: (error) => {
        deps.store.connectionStateChanged({
          status: 'error',
          errorMessage: error.message,
          nowEpochMs: Date.now(),
        });
      },
    });

    return {
      unsubscribe: () => {
        subscription.unsubscribe();
        deps.store.connectionStateChanged({
          status: 'disconnected',
          nowEpochMs: Date.now(),
        });
      },
    };
  },
});
